// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__167l2","title":"styles_title__3MGOO"};